import $ from 'jquery'; // note that window.$ = window.JQuery = $;

const changePopup = require('./modules/change-story-popup').default;


$(document).ready(() => {

  changePopup.init();

});